import Cookies from 'js-cookie';
import { CookieEnum } from '../../enums/cookie-enum';

export const getCurrentUserId = () =>
  JSON.parse(Cookies.get(CookieEnum.USER) || '{}').id;
